import { Expose } from 'class-transformer';

export class RepeatableGuestDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'full_name' })
  fullName: string;
  @Expose({ name: 'email' })
  email?: string;
  @Expose({ name: 'phone' })
  phone?: string;
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'company_id' })
  companyId: number;
  @Expose({ name: 'company_space_id' })
  companySpaceId: number;
  @Expose({ name: 'start_date' })
  startDate: number;
  @Expose({ name: 'end_date' })
  endDate: number;
  @Expose({ name: 'license_number' })
  licenseNumber: string;
  @Expose({ name: 'parking_floor_number' })
  parkingFloorNumber: string;
  @Expose({ name: 'parking_number' })
  parkingNumber: string;
  @Expose({ name: 'created_at' })
  createdAt: number;
}
